import core from './endpoints/core'
import user from './endpoints/user'
import card from './endpoints/card'
import archive from './endpoints/archive'
import integration from './endpoints/integration'

const api = {
  core,
  user,
  card,
  archive,
  integration,
}

export default api
